import React from 'react';
import SubHeader2 from '../../../resources/image/subHeader2_3.png';
import ScrollToTop from '../../atoms/scrollToTop';
import { SubHeader } from '../../molecules/subHeader';
import { HeaderContainer } from '../../organisms/common/headerContainer';
import MembershipCancelPopup from '../../organisms/common/membershipCancelPopup';
import InputUserPopupContainer from '../../organisms/hotel/inputUserPopupContainer';
import MembershipReservationPopupContainer from '../../organisms/common/membershipReservationPopupContainer';
import MembershipConfirmUserContainer from '../../organisms/hotel/membershipConfirmUserContainer';
import CrawlSenyuubiPopupContainer from '../../organisms/common/crawlSenyuubiPopupContainer';
import { DescriptionHomeFlContainer } from '../../organisms/common/descriptionHomeFlContainer';

class MembershipConfirmUserTemplate extends React.Component {

    render() {
        return (
            <>
                <ScrollToTop />
                <HeaderContainer
                    Label categoryLabel1={"入力内容確認"}
                    categoryLabel2={"CONFIRM"}
                    path={"/reserve/hotel/inputUser"}
                    bookedConfirmLabel={"＞予約内容の確認・変更・キャンセルはこちら"}
                    onClickOpenReservationPopupWindow={this.props.onClickOpenReservationPopupWindow}
                    onClickOpenSenyuubiWindow={this.props.onClickOpenSenyuubiWindow}
                />
                <SubHeader SubImage={SubHeader2} />
                <MembershipConfirmUserContainer
                    state={this.props.state}
                    setPopupData={this.props.setPopupData}
                    setPopupMessage={this.props.setPopupMessage}
                    onClickClosePopupWindow={this.props.onClickClosePopupWindow}
                />
                <CrawlSenyuubiPopupContainer
                    state={this.props.state}
                    onClickOpenDescriptionHomeFlWindow={this.props.onClickOpenDescriptionHomeFlWindow}
                    onClickCloseSenyuubiPopupWindow={this.props.onClickCloseSenyuubiPopupWindow}
                />
                <DescriptionHomeFlContainer
                    state={this.props.state}
                    onClickCloseDescriptionHomeFlWindow={this.props.onClickCloseDescriptionHomeFlWindow}
                />
                <MembershipReservationPopupContainer
                    state={this.props.state}
                    onClickClosePopupWindow={this.props.onClickCloseReservationConfPopupWindow}
                    onClickOpenCancelPopupWindow={this.props.onClickOpenCancelPopupWindow}
                />
                <MembershipCancelPopup
                    state={this.props.state}
                    onClickCloseCancelPopupWindow={this.props.onClickCloseCancelPopupWindow}
                />
                <InputUserPopupContainer
                    state={this.props.state}
                    onClickClosePopupWindow={this.props.onClickClosePopupWindow}
                />
            </>
        )
    }
}
export default MembershipConfirmUserTemplate;